import React from 'react';
import { Card, Item, Label, Button } from 'semantic-ui-react';
import Image from '../../../atoms/Image';
import labels from '../data/labels';

export default ({
  itemThumbnail,
  itemPrice,
  itemTitle,
  itemDescription,
  itemNote,
  itemLabels,
  labelAsImage,
  itemCTALink,
  imageSize,
  itemAs,
  align,
}) => {
  if (itemAs === 'Item') {
    const displayImage = <Item.Image size={imageSize} src={itemThumbnail} />;
    return (
      <Item.Group>
        {align === 'center' && itemThumbnail && displayImage}
        <Item>
          {align === 'left' && itemThumbnail && displayImage}
          <Item.Content>
            <Item.Header style={{ fontSize: '1.3em', lineHeight: '1em' }}>{itemTitle}</Item.Header>
            {itemDescription && (
              <Item.Description style={{ fontSize: '1em', lineHeight: '1.3em', marginTop: '0em' }}>
                {itemDescription}
              </Item.Description>
            )}
            {itemPrice && (
              <Item.Meta style={{ fontSize: '1em', lineHeight: '1em', marginTop: '0.5em' }}>
                {itemPrice}
              </Item.Meta>
            )}
            <Item.Extra>
              {itemNote && <div style={{ fontStyle: 'italic' }}>{itemNote}</div>}
              <div>
                {itemLabels &&
                  itemLabels.map(label => {
                    if (labelAsImage && label in labels) {
                      return (
                        <Image
                          key={label}
                          size="mini"
                          src={labels[label]}
                          style={{ display: 'inline-block' }}
                        />
                      );
                    }
                    return (
                      <Label key={label} size="tiny">
                        {label}
                      </Label>
                    );
                  })}
              </div>
              {itemCTALink && (
                <Button
                  style={{ marginTop: '10px' }}
                  as="a"
                  target="_blank"
                  href={itemCTALink}
                  primary
                >
                  Order Now
                </Button>
              )}
            </Item.Extra>
          </Item.Content>
        </Item>
      </Item.Group>
    );
  }
  return (
    <Card fluid centered>
      {itemThumbnail && <Image src={itemThumbnail} centered fluid />}
      <Card.Content style={{ border: 'none' }}>
        <Card.Header style={{ fontSize: '1.5em', lineHeight: '1.5em' }}>{itemTitle}</Card.Header>
        {itemPrice && (
          <Card.Meta style={{ fontSize: '1.3em', lineHeight: '1.3em' }}>{itemPrice}</Card.Meta>
        )}
        {itemDescription && <Card.Description>{itemDescription}</Card.Description>}
      </Card.Content>
      {(itemNote || itemLabels || itemCTALink) && (
        <Card.Content style={{ border: 'none' }} extra>
          {itemNote && <div>{itemNote}</div>}
          <div>
            {itemLabels &&
              itemLabels.map(label => {
                if (labelAsImage && label in labels) {
                  return (
                    <Image
                      key={label}
                      size="mini"
                      src={labels[label]}
                      style={{ display: 'inline-block' }}
                    />
                  );
                }
                return (
                  <Label key={label} size="tiny">
                    {label}
                  </Label>
                );
              })}
          </div>
          {itemCTALink && (
            <Button style={{ marginTop: '10px' }} as="a" target="_blank" href={itemCTALink} primary>
              Order Now
            </Button>
          )}
        </Card.Content>
      )}
    </Card>
  );
};
